<section class="modal-container" aria-label="Privacy Settings Modal" role="dialog">
  <header>
    <h2>
      {{ 'aria-labels.document' | translate }}
      {{ 'aria-labels.settings' | translate }}
    </h2>
    <button (click)="cancel()" aria-label="Close">
      <img src="../../../../../../assets/report_v2/close_big.svg" alt="close" />
    </button>
  </header>
  <section class="document_settings">
    <p>{{ 'general.choose_language' | translate }}:</p>
    <app-translate></app-translate>
  </section>
</section>
